import React, { Children } from "react"

export function Section({ name, children}) {
  return(
    <section className={ `section-${name}` }>
      {children}
    </section>
  )
}